import { toast } from "react-toastify";

import { t } from '@common/helpers/translator';

import { store } from "../../../index/terminalApp";

export const restrictForLoggedIn = cb => {
    let activeToastId;

    return (...args) => {
        const { user } = store.getState();

        if (!user?.loggedIn && !user?.loggedInByRFID) {
            
            if (!toast.isActive(activeToastId))
                activeToastId = toast.info(t("Please login to join a tournament"));
                
            return;
        }
    
        cb(args);
    }
};